import React, { useEffect, useMemo } from "react";
import Image from "../../../../component/image/Image";
import ArrowLeft from "../../../../assets/images/clients/arrow-left.svg";
import "../../../../styles/client/joblistingclient.scss";
import { publishingDate } from "../CareersFucConfig";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import JobApplay from "../jobapplication/JobApplay";
import breathesafeBannerImg from "../../header/clientsMenu/template_9/images/job_view_Banner.svg";
import { clientIds } from "../../../../config/clients/clients";
import useClientConfig from "../../../../config/careers/clientConfig";
import SimilarJobs from "../OptionThree/SimilarJobs";

const JobViewClient = (props: any) => {

  const { routerLocation, routeParams, titleSection, titleSectionWithoutPositionBtn, jobLogo, ApplayNowButton, listOfPoint,description, 
    imgAndVideo, jobDetails, filterViewClient, cliendConfig, similarJobList } = props;

  const navigate = useNavigate();
  const clientId = useParams();
  const location = useLocation();
  const {clientSiteSettings, clientAssetsLink} = useClientConfig();
  const templateName = clientSiteSettings?.templateName;
  const headerName = clientSiteSettings?.headerComponentName;
  const customClientFolderName = clientSiteSettings?.customClientFolderName;
  //by default showSimilarJobs is true
  const showSimilarJobs = clientSiteSettings?.showSimilarJobs !== undefined ? clientSiteSettings.showSimilarJobs : true;

  
  const redirectListing = () => {
    navigate("/");
  };

  useEffect(() => {
    if(location.pathname === `/view/${clientId?.id}`){
        const reOrder = () => {
            let mq = window?.matchMedia("(min-width: 1349px)");
            let mqhr = window?.matchMedia("(min-width: 1681px)");

            if (mqhr.matches) {
                $(".right-child").addClass("customm");
                let scroll: any = $(window)?.scrollTop();
                let topContent = $(".inner").position()?.top - 30;

                // had to add this condition to avoid style issues
                // add headerName in array which does not have banner section in page
                const ignoreArr = ["CosHeader","EtgHeader"];
                if(templateName === "template_9" && !ignoreArr.includes(headerName)){
                    topContent = $(".inner").position()?.top + 510;
                }
                
                let sectionHeight: any = $(".job-details")?.height();
                let rightHeight: any = $(".right-child")?.height();
                let bottomContent = topContent + sectionHeight - rightHeight - 60;

                if(templateName === "template_9"){
                    if (sectionHeight > 600) {
                        bottomContent = topContent + sectionHeight - rightHeight + 0;
                    }                    
                }
        
                if (scroll > topContent && scroll < bottomContent) {
                    $(".customm").removeClass("posAbs").addClass("posFix");
                } else if (scroll > bottomContent) {
                    $(".customm").removeClass("posFix").addClass("posAbs");
                }  else if (scroll < topContent) {
                    $(".customm").removeClass("posFix");
                }
            } else if (mq.matches) {
                $(".right-child").addClass("customm");
                let scroll: any = $(window)?.scrollTop();
                let topContent = $(".inner").position()?.top - 30;
                if(templateName === "template_9"){
                    topContent = $(".inner").position()?.top + 380;
                }

    
                
                let sectionHeight: any = $(".job-details")?.height();
                let rightHeight: any = $(".right-child")?.height();
                let bottomContent = topContent + sectionHeight - rightHeight - 60;

                if(templateName === "template_9"){
                    if (sectionHeight > 500) {
                        bottomContent = topContent + sectionHeight - rightHeight + 50;
                    }
                }
        
                if (scroll > topContent && scroll < bottomContent) {
                    $(".customm").removeClass("posAbs").addClass("posFix");
                } else if (scroll > bottomContent) {
                    $(".customm").removeClass("posFix").addClass("posAbs");
                }  else if (scroll < topContent || scroll === topContent) {
                    $(".customm").removeClass("posFix");
                }
            } else {
                $(".right-child").removeClass("customm posAbs posFix");
            }
            
            
            
        };

        $(window).on("scroll", reOrder);
        $(window).on("resize", reOrder);
    }
  }, [window]);

  const jobViewColorSettings = useMemo(() => {
    const colorSettings = cliendConfig?.data?.data?.clientSettings?.colorSettings?.jobView;
    return colorSettings?.[0];
  }, [cliendConfig]);

//   const applyPath = useMemo(() => {
//     return routerLocation.pathname === `/careers/job-list/${clientId?.userId}/view/${clientId?.id}`;
//   }, [routerLocation.pathname]);

//   const content = useMemo(() => {
//     return !applyPath ? <JobApplay jobFilterData = {filterViewClient} /> : "";
//   }, [applyPath]);

const styles = {
    jobDetailDecsWrap: {
        color: jobViewColorSettings?.rightSideDescriptionText
    }
};

  return (  
    <>
        { routerLocation.pathname === `/view/${clientId?.id}` ?
            
            <>  
                <style>
                    {`
                        .jobDetailDecsWrap a {
                            color: ${jobViewColorSettings?.rightSideLinks} !important;
                        }
                        .jobListPointsWrap a{
                            color: ${jobViewColorSettings?.rightSideLinks} !important;
                        }
                        .default-theme-template-new-page-id-2 .container {
                            background-color: ${jobViewColorSettings?.bodyBackground} !important;;
                        }
                         @media screen and (min-width: 981px){   
                             .head-parent{ 
                            background-color: ${jobViewColorSettings?.headerBackground} !important;
                        }
                    `}
                </style>
                { (templateName === "template_9" && !customClientFolderName) ? (
                    <div className="theme-new-page-id-2-banner-view-page">
                        <img src={clientAssetsLink+"/job_view_Banner.svg"} alt="" decoding="async"  />
                    </div>  
                ) : "" }  
                <div className="container">
                    <div className="module-careers-listings careers-view">
                        <div  className="flex">
                            <div className="job-view">
                                <div className="apply-inner" style={{ background: jobViewColorSettings?.titleBackground }}>
                                    <div className="apply-image">
                                        {jobLogo()}
                                    </div>
                                    <div className="apply-text">
                                        <h5 className="h5-client" role="button" style={{ color: jobViewColorSettings?.titleText }}>{titleSection()}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex">
                            <div className="job-view">
                                <div className="inner">
                                    <div className="job-detail" style={{ background: jobViewColorSettings?.leftSideBackground, border: `2px solid ${jobViewColorSettings?.leftSideBorder}` }}>
                                        <div className="right-child">
                                            <div className="backtolisting">
                                                <button type="button" className="arrow prev" onClick={redirectListing}>
                                                    <span className="icon">
                                                        <Image src={ArrowLeft} alt="arrow" />
                                                        
                                                    </span>
                                                    <h6 style={{ color: jobViewColorSettings?.leftSideCategoryLabelText }}>BACK TO LISTINGS</h6>
                                                </button>
                                            </div>
                                            <h3 style={{ color: jobViewColorSettings?.leftSideTitleText }}>{titleSectionWithoutPositionBtn()}</h3>
                                            <div className="d-lg-flex d-md-flex  d-flex d-sm-flex align-items-center" >
                                                {ApplayNowButton()}
                                            </div>
                                            <h6 style={{ color: jobViewColorSettings?.leftSideCategoryLabelText }}>LOCATION</h6>
                                            <h5 style={{ color: jobViewColorSettings?.leftSideCategoryValueText }}>{jobDetails?.data?.data?.job?.location?.location}</h5>
                                            <h6 style={{ color: jobViewColorSettings?.leftSideCategoryLabelText }}>TYPE</h6>
                                            <h5 style={{ color: jobViewColorSettings?.leftSideCategoryValueText }}>{jobDetails?.data?.data?.job?.jobType}</h5>
                                            <h6 style={{ color: jobViewColorSettings?.leftSideCategoryLabelText }}>CATEGORY</h6>
                                            <h5 style={{ color: jobViewColorSettings?.leftSideCategoryValueText }}>{jobDetails?.data?.data?.job?.category}</h5>
                                            <h6 style={{ color: jobViewColorSettings?.leftSideCategoryLabelText }}>REFERENCE ID</h6>
                                            <h5 style={{ color: jobViewColorSettings?.leftSideCategoryValueText }}>{jobDetails?.data?.data?.job?.referenceNo}</h5>
                                            <h6 style={{ color: jobViewColorSettings?.leftSideCategoryLabelText }}>DATE POSTED</h6>
                                            <h5 style={{ color: jobViewColorSettings?.leftSideCategoryValueText }}>{publishingDate(jobDetails?.data?.data?.job?.postedAt)}</h5>
                                            <h6 style={{ color: jobViewColorSettings?.leftSideCategoryLabelText }}>APPLICATIONS CLOSE</h6>
                                            <h5 style={{ color: jobViewColorSettings?.leftSideCategoryValueText }}>{jobDetails?.data?.data?.job?.displayExpiryDate === true ? publishingDate(jobDetails?.data?.data?.job?.expiryDate) : "-"}</h5>
                                        </div>
                                    </div>
                                    <div className="job-details" style={{ background: jobViewColorSettings?.rightSideBackground, border: `2px solid ${jobViewColorSettings?.leftSideBorder}` }}>
                                        <div className={`${routerLocation.pathname ===
                                            `/view/${routeParams?.id}`
                                            ? "col-xxl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-md-0 section-common-para mt-2"
                                            : "col-md-12 section-common-para"
                                            }`} >
                                            <h6 className="mb-3" style={{ color: jobViewColorSettings?.leftSideCategoryLabelText }}>ABOUT THE JOB</h6>
                                            <div className="row">
                                                <div className={    
                                                    routerLocation.state !==
                                                    `/view/${routeParams?.id}/apply-job`
                                                    ? "col-lg-9 col-md-12 col-sm-12 col-12"
                                                    : "col-md-12"
                                                    } style={{ color: jobViewColorSettings?.rightSideTitleText }}>{titleSection()}
                                                </div>
                                            </div>
                                            {/* <div className="d-lg-flex d-md-flex  d-flex d-sm-flex align-items-center job-view-desc-sec">
                                                {jobDetailDownloadLink()}
                                            </div> */}
                                            <div className="jobListPointsWrap" style={styles.jobDetailDecsWrap}>{listOfPoint()}</div>
                                            <div className="jobDetailDecsWrap" style={styles.jobDetailDecsWrap}>{description()}</div>
                                            <div>{imgAndVideo()}</div>
                                        </div>

                                        <div className="section-common-para">       
                                            {/* <h6>WHAT TO DO NEXT</h6>
                                            <h4>To apply for this role, click the &apos;Apply for this job&lsquo; button and then follow the steps to complete your application. You can also apply online at www.hvtc.com.au by clicking on &apos;Vacancies&lsquo; and selecting the relevant position, then the &#39;Apply Online&rsquo; button at the top of the page.</h4>
                                            <h5>What else is involved?</h5>
                                            <p>Lörem ipsum geska ora sel dekaktig vust, pirad vuktig. Trektigt salogi san samt ryposkap orat, anaviren. Byrade fakada, ninde än kontrafasat alltså oligt. Deligt evura depp tetraktig: tills exoligen att biogende mimåra. Intradade tedesamma div i fask. Homonoling posade autor sevis, ett anteskap. Dossa multina tinegen aponomi förutom paracentrism. Mitisk nypp gihur dade den sepire, jegyska.</p> */}
                                            {ApplayNowButton()}
                                            {/* <p>After submitting your online application, you may be invited to complete online testing, interviews, and pre-employment medicals. We may also contact your references. Please be sure to check your emails (including your junk folder) and respond to missed phone calls, voicemail messages and text messages.</p>
                                            <p>Your resident experts for this opportunity will be Nicole Lean, you can contact Nicole for a confidential conservation on 02 4932 4222</p>
                                            <p>As a recognised Diversity Champion, HVTC is committed to Equal Employment Opportunities, Ethical Practices, and the principles of Cultural Diversity. We encourage applications from all members of the community, including people from indigenous backgrounds, people with disability, women seeking non-traditional trade opportunities, people from culturally and linguistically diverse backgrounds, and mature aged people. If you require assistance lodging your application with HVTC, please contact our Recruitment Team on 1800 247 864.</p> */}
                                        </div>    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showSimilarJobs &&
                        <div className="similar_jobs_wrap">                    
                            <SimilarJobs similarJobList = {similarJobList}/>
                        </div>
                    }
                </div>
            </>
            : <JobApplay jobFilterData = {filterViewClient} /> }
    </>
  );
};

export default React.memo(JobViewClient);